import { useLang } from "../../lib/i18n";

export const LangToggle = () => {
  const { lang, setLang } = useLang();
  return (
    <div data-testid="language-toggle" className="flex items-center rounded-full border border-[#E6D9BC]/25 p-0.5 font-mono text-[11px] tracking-[0.15em]">
      {["fr", "en"].map((l) => (
        <button
          key={l}
          data-testid={`language-option-${l}`}
          onClick={() => setLang(l)}
          aria-pressed={lang === l}
          className={`rounded-full px-3 py-1.5 uppercase transition-colors duration-300 ${lang === l ? "bg-[#E6D9BC] text-[#1E2A32]" : "text-[#BAC6CE] hover:text-[#F4EFE6]"}`}
        >
          {l}
        </button>
      ))}
    </div>
  );
};
